import { cn } from "../lib/utils";

interface DividerProps {
  dividerText?: React.ReactNode;
  className?: string;
}

export function Divider({ dividerText, className }: DividerProps) {
  if (dividerText) {
    return (
      <div
        className={cn(
          "flex items-center justify-center w-full gap-2",
          className ?? ""
        )}
      >
        <div className="h-px w-full bg-gray-200" />
        <span className="text-gray-500 px-2 whitespace-nowrap">
          {dividerText}
        </span>
        <div className="h-px w-full bg-gray-200" />
      </div>
    );
  }
  return (
    <div className={cn("h-px w-full bg-gray-200 my-4", className ?? "")} />
  );
}
